import React from 'react';

import PropTypes from 'prop-types';

import { ActionButton } from 'components/ActionButton/ActionButton';
import { CustomModal } from 'components/CustomModal';

import './Popup.sass';

export const MissingExpertDataPopup = ({ isOpen, onClose }) => {
  return (
    <CustomModal
      isOpen={isOpen}
      title="Hinweis"
      closeCancelEventModal={onClose}
      ctaButtons={<ActionButton title="Ok" onClick={onClose} />}
      content={
        <div className="popup-content">
          <div className="popup-content__popup-subtext">
            Bei einer oder mehreren Fachkräften fehlen Angaben.
            <br />
            Diese Fachkräfte haben wir für Sie rot markiert. Wählen Sie aus, ob diese gelöscht oder
            verlängert werden sollen.
            <br />
            Fachkräfte mit fehlende Angaben werden durch uns inaktiv gesetzt.
          </div>
        </div>
      }
    />
  );
};

MissingExpertDataPopup.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

MissingExpertDataPopup.displayName = 'MissingExpertDataPopup';
